import React, { FC } from 'react';

import Loader from 'components/common/ui-kit/Loader';
import Consent from 'components/statements/Consent';
import FillingStatementsForm from 'components/statements/FillingStatementsForm';
import Informing from 'components/statements/Informing';
import useAppSelector from 'hooks/common/useAppSelector';
import useFillingStatementsRoutesContext from 'hooks/statements/useFillingStatementsRoutesContext';
import { EducationBasis } from 'models/staff/upload-queue';
import { useGetApplicationAgreementsQuery } from 'redux/api/applications/applications-api';
import { contractApi } from 'redux/api/applications/contract-api';
import { selectApplication } from 'redux/selectors/enrollee/application';

import { ApplicationEducationLevel } from '../../../models/applications/enum';
import { selectIsUserAdmin } from '../../../redux/selectors';

const InformingAndAgreementsPage: FC = () => {
  const { onNextPageNavigate } = useFillingStatementsRoutesContext();
  const isAdmin = useAppSelector(selectIsUserAdmin);
  const application = useAppSelector(selectApplication);
  const { data: contracts } = contractApi.useGetByApplicationIdQuery(
    // @ts-expect-error it's okay
    application?.id,
    {
      skip: !application?.id,
    }
  );

  const { data: agreements } = useGetApplicationAgreementsQuery(
    // @ts-expect-error it's okay
    application?.id,
    {
      skip: !application?.id,
    }
  );

  if (!contracts || !application || !agreements) {
    return <Loader />;
  }

  const today = new Date().getTime();

  const isConsentDisabled =
    application.educationBasis !== EducationBasis.BUDGET;

  const informingStartDateBachelor = process.env.INFORMING_START_DATE_BACHELOR;
  const informingEndDateBachelor = process.env.INFORMING_END_DATE_BACHELOR;

  const informingStartDateMaster = process.env.INFORMING_START_DATE_MASTER;
  const informingEndDateMaster = process.env.INFORMING_END_DATE_MASTER;

  const informingStartDateGraduate = process.env.INFORMING_START_DATE_GRADUATE;
  const informingEndDateGraduate = process.env.INFORMING_END_DATE_GRADUATE;

  const getInformingDates = (educationLevel: ApplicationEducationLevel) => {
    switch (educationLevel) {
      case ApplicationEducationLevel.BACHELOR:
        return {
          start: informingStartDateBachelor,
          end: informingEndDateBachelor,
        };
      case ApplicationEducationLevel.MASTER:
        return {
          start: informingStartDateMaster,
          end: informingEndDateMaster,
        };
      case ApplicationEducationLevel.GRADUATE:
        return {
          start: informingStartDateGraduate,
          end: informingEndDateGraduate,
        };
      default:
        return { start: null, end: null };
    }
  };

  const isInformingDateValid = (
    date: number | Date,
    educationLevel: ApplicationEducationLevel
  ) => {
    const inputDate = new Date(date).getTime();
    const { start, end } = getInformingDates(educationLevel);
    if (!start || !end) return true;

    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();
    return inputDate >= startTime && inputDate <= endTime;
  };

  // Не удалять. По ходу ПК может вернуться необходимость проверять статус договора
  // const isContractStateValid = (contract: Contract) => {
  //   return (
  //     contract.state === ContractState.RECEIVED ||
  //     contract.state === ContractState.CONFIRMED
  //   );
  // };

  const isInformingDisabled =
    // Нет смысла удалять эту строку - по ходу ПК ее дергают туда-сюда
    // !contracts.some(contract => isContractStateValid(contract)) ||
    (application.educationBasis !== EducationBasis.CONTRACT ||
      !isInformingDateValid(today, application.educationLevel)) &&
    !isAdmin;

  return (
    <FillingStatementsForm
      onSubmit={e => {
        e.preventDefault();
        onNextPageNavigate();
      }}
    >
      <div style={{ display: 'flex', gap: 20, flexDirection: 'column' }}>
        <Consent
          hasConcent={agreements[0]?.isAgreed ?? false}
          disabled={isConsentDisabled}
        />
        <div>
          {application.educationLevel !==
            ApplicationEducationLevel.SECONDARY && (
            <Informing disabled={isInformingDisabled} />
          )}
        </div>
      </div>
    </FillingStatementsForm>
  );
};

export default InformingAndAgreementsPage;
